import AppPage from "layouts/AppPage";

export default function SettingsPage() {
  return (
    <AppPage>
      <h1>Settings Page</h1>
    </AppPage>
  );
}
